import React from 'react';
import { Redirect } from 'react-router-dom';

const ZoneSetup = ({ zone, config, props }) => {
  const { prompts } = zone;
  const { searchAtFirst, shouldSeeDistrictSelector } = config;
  const { prevRoute } = props.location.state || { prevRoute: '' };

  return (
    <>
      {
        !!(
          prompts
          && prompts.length
          && prompts[0].zoneSelectOptions
          && prompts[0].zoneSelectOptions.map
        )
        && (
          <Redirect to={{
            pathname: '/zone-setup/map',
            state: { prevRoute }
          }}
          />
        )
      }
      {
        !!(
          prompts
          && prompts.length
          && prompts[0].zoneSelectOptions
          && !prompts[0].zoneSelectOptions.map
          && prompts[0].zoneSelectOptions.list
        )
        && (
          <Redirect to={{
            pathname: '/zone-setup/list',
            state: prevRoute
          }}
          />
        )
      }
      {
        !!(
          (
            prompts
            && prompts.length
            && prompts[0].zoneSelectOptions
            && prompts[0].zoneSelectOptions.search
            && !prompts[0].zoneSelectOptions.map
          )
          || (
            searchAtFirst
            && (
              (prompts
              && prompts.length
              && prompts[0].zoneSelectOptions
              && !prompts[0].zoneSelectOptions.map
              && !prompts[0].zoneSelectOptions.list)
              || (
                prompts
                && !prompts.length
              )
            )
          ) || (
            prompts
            && !prompts.length
            && !searchAtFirst
            && !shouldSeeDistrictSelector
          )
        )
        && (
          <Redirect to={{
            pathname: '/zone-setup/search',
            state: prevRoute
          }}
          />
        )
      }
    </>
  );
};

export default ZoneSetup;
